import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LigneFinancementSecteur } from '../../core/model/ligneFinancement/ligneFinancementSecteur';
import { LigneFinancementSecteurService } from '../../core/service/ligne-financement/ligne-financement-secteur.service';
import { EditLigneFinancementSecteurComponent } from './edit-ligne-financement-secteur/edit-ligne-financement-secteur.component';
import { AddLigneFinancementSecteurComponent } from './add-ligne-financement-secteur/add-ligne-financement-secteur.component';

@Component({
  selector: "app-ligne-financement-secteur",
  templateUrl: "./ligne-financement-secteur.component.html",
  styleUrls: ["./ligne-financement-secteur.component.scss"]
})
export class LigneFinancementSecteurComponent implements OnInit {
  ligneFinancement: LigneFinancementSecteur[];

  constructor(
    private modalService: NgbModal,
    private _ligneFinancementService: LigneFinancementSecteurService
  ) {}

  ngOnInit() {
    this.getAll();
  }

  getAll() {
    this._ligneFinancementService.getAllLigneFinancementSecteur().subscribe(
      data => {
        this.ligneFinancement = data;
      },
      error => {
        console.log(error);
      }
    );
  }

  edit(ligneFinancement: LigneFinancementSecteur): void {
    const modalRef = this.modalService.open(
      EditLigneFinancementSecteurComponent,
      {
        centered: true
      }
    );
    modalRef.componentInstance.ligneFinancement = ligneFinancement;

    modalRef.result.then(
      data => {
        // on close
        this.getAll();
      },
      reason => {
        // on dismiss
      }
    );
  }

  add(): void {
    const modalRef = this.modalService.open(
      AddLigneFinancementSecteurComponent,
      {
        centered: true
      }
    );

    modalRef.result.then(
      data => {
        // on close
        this.getAll();
      },
      reason => {
        // on dismiss
      }
    );
  }
}
